<ion-content>
  <nav class="navbar sub-navigation with-overflow">
    <ul class="navbar-secondary">  
      <li *ngFor="let cat of allCategories;  index as i">

        <a id="aTag" (click)="switch_SportCategories(cat,$event)" class="sport-link-racing border-home" [ngClass]="{'active':cat.active}">
          <img src="{{cat.imageIcon}}" class="icon" id="imgTag" />
          {{cat.sport_name | translateSports}}
        </a>
    </li>
  
</ul>
</nav>
    
    <app-in-play-odds [selectedBetCategory]='selectedBetCategory'></app-in-play-odds>
    
</ion-content>
